import { ProductCarouselProduct } from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { CatalogServiceProductData } from 'src/services/catalog';

export const transformProductModelToProductCarouselProduct = (
  {
    images,
    isNew,
    links,
    onSale,
    salePercentage,
    preSalePrices,
    prices,
    purchasable,
    title,
  }: CatalogServiceProductData,
  { currency }: { currency: CurrencyCode },
): ProductCarouselProduct => ({
  title,
  src: images[0]?.href || '',
  href: links[0]?.href || '',
  alt: '',
  isNew,
  onSale,
  isPurchasable: purchasable,
  price: prices?.find((prices) => prices.currency === currency),
  preSalePrice: preSalePrices?.find((price) => price.currency === currency),
  salePercentage: salePercentage ?? undefined,
});
